define(
    ['jquery',
        'core/urls',
        'components/datatable',
        'components/daterangepicker-v2',
        'core/loading-animation',
        'core/formatting',
        'components/dropdown',
    ],
    function(
        $, 
        urls, 
        datatable, 
        drp, 
        loading_animation, 
        formatting, 
        DD
    ){

        let nodes = {
            reportSelector: document.querySelector(".report-selector"),
        }

        let reportSelectorDD;

        function getReportUrl(currentSelection) {
            return urls['csat:reports:performance-report'](currentSelection, drp.getStartDate().format('YYYY-MM-DD'), drp.getEndDate().format('YYYY-MM-DD'));
        }

        function updateReportDatatable() {
            loading_animation.start();
            var currentSelection = document.querySelector("#csat-report-type").value;
            var currentSelectionTitle = $('#csat-report-type option:selected').text();

            $('#csat-report-header').removeClass('hidden');
            $('#csat-report-title-group').text(currentSelectionTitle);

            if (window.report) {
                window.report.destroy();
                $('#csat-report').empty();
            }

            var monthTable = {
                Jan: '01',
                Feb: '02',
                Mar: '03',
                Apr: '04',
                May: '05',
                Jun: '06',
                Jul: '07',
                Aug: '08',
                Sep: '09',
                Oct: '10',
                Nov: '11',
                Dec: '12'
            };
            
            window.report = datatable.create('#csat-report', {
                language: {
                },
                columns: [
                    {
                        title: currentSelectionTitle,
                        className: 'column-' + currentSelection,
                        width: "200px",
                        data: currentSelection,
                        render: {
                            _: $.fn.dataTable.render.text(),
                            sort: currentSelection === 'month' ?
                                    function (data) {
                                        return data.substring(0, 4) + '-' + monthTable[data.substring(5, 8)] + '-01';
                                    } : undefined
                        }
                    },
                    {
                        title: 'Net CSAT Score',
                        className: 'column-net-csat-score',
                        data: 'net_csat_score',
                        render: {
                            _: null,
                            display: formatting.asNetCsatScore
                        }
                    },
                    {
                        title: 'Response Rate',
                        className: 'column-response-rate',
                        data: 'response_rate',
                        render: {
                            _: null,
                            display: formatting.asResponseRate
                        }
                    },
                    {
                        title: 'Reviews',
                        className: 'column-total-reactions',
                        data: 'total_reactions',
                        render: {
                            _: null,
                            display: formatting.asReviewCount
                        }
                    },
                    {
                        title: '<div class="image-wrapper positive rate"><img src="' + globals.getSentimentImageUrl(+1) + '" height="30" width="30" alt="Positive Rate"></div><span class="export-header">Positive Rate</span>',
                        className: 'column-positive-rate',
                        data: 'positive_rate',
                        render: {
                            _: null,
                            display: formatting.asPercentageOrDash
                        }
                    },
                    {
                        title: '<div class="image-wrapper positive count"><img src="' + globals.getSentimentImageUrl(+1) + '" height="30" width="30" alt="Positive Count"></div><span class="export-header">Positive Count</span>',
                        className: 'column-positive-count',
                        data: 'positive_num',
                        render: {
                            _: null,
                            display: formatting.asReviewCountOrDash
                        }
                    },
                    {
                        title: '<div class="image-wrapper neutral rate"><img src="' + globals.getSentimentImageUrl(0) + '" height="30" width="30" alt="Neutral Rate"></div><span class="export-header">Neutral Rate</span>',
                        className: 'column-neutral-rate',
                        data: 'neutral_rate',
                        render: {
                            _: null,
                            display: formatting.asPercentageOrDash
                        }
                    },
                    {
                        title: '<div class="image-wrapper neutral count"><img src="' + globals.getSentimentImageUrl(0) + '" height="30" width="30" alt="Neutral Count"></div><span class="export-header">Neutral Count</span>',
                        className: 'column-neutral-count',
                        data: 'neutral_num',
                        render: {
                            _: null,
                            display: formatting.asReviewCountOrDash
                        }
                    },
                    {
                        title: '<div class="image-wrapper negative rate"><img src="' + globals.getSentimentImageUrl(-1) + '" height="30" width="30" alt="Negative Rate"></div><span class="export-header">Negative Rate</span>',
                        className: 'column-negative-rate',
                        data: 'negative_rate',
                        render: {
                            _: null,
                            display: formatting.asPercentageOrDash
                        }
                    },
                    {
                        title: '<div class="image-wrapper negative count"><img src="' + globals.getSentimentImageUrl(-1) + '" height="30" width="30" alt="Negative Count"></div><span class="export-header">Negative Count</span>',
                        className: 'column-negative-count',
                        data: 'negative_num',
                        render: {
                            _: null,
                            display: formatting.asReviewCountOrDash
                        }
                    }
                ],
                order: [[0, 'asc']],
                ajax: {
                    url: getReportUrl(currentSelection)
                },
                responsive: {
                    // turn off child expanding feature
                    details: false
                },
                columnDefs: [
                    {
                        targets: '_all',
                        orderSequence: ['desc', 'asc'], 
                    }
                ],
                dom: 'Br<"table-wrap"t>',
                buttons: [
                    {
                        extend: 'csv',
                        className: 'button-secondary csv',
                        text: '<span>CSV <img src="/static/icons/csv_arrow.svg" alt=""></span>',
                        exportOptions: {
                            orthogonal: 'exportTabular'
                        },
                        filename: function() {
                            var dateRange = drp.getStartDate().format('YYYY-MM-DD') + ' - ' + drp.getEndDate().format('YYYY-MM-DD');
                            return 'Client Satisfaction by ' + currentSelectionTitle + ' - ' + dateRange + ' - SmileBack';
                        },
                        init: (api, node) => {
                            $(node).removeClass('btn btn-secondary buttons-html5');
                        }
                    }
                ],
                info: false,
                lengthChange: false,
                paging: false,
                searching: false,
                stateSave: false,
                responsive: false,
                initComplete: function() {
                    if (this.api().page.info().recordsDisplay !== 0) {
                        $('#no-data').hide(); // hide no-data alert message
                        $('#data-area').removeClass('hide'); // return data-area div to normal state
                    } else {
                        $('#no-data').show(); // show no-data alert message
                        $('#data-area').addClass('hide'); // set data-area div opacity to 50%, add blur and disable pointerevents, via css classes
                    }
                    loading_animation.complete();
                    drp.saveToBrowserStorage('csat-report');
                },
            });
        }

        return {
            init: function() {
                // initialize the daterangepicker
                drp.create(updateReportDatatable);
                drp.loadFromBrowserStorage('csat-report');

                // update data table whenever someone changes the type of report
                $('').change(updateReportDatatable);

                reportSelectorDD = DD(nodes.reportSelector, () => { 
                    updateReportDatatable();
                });

                // show all controls only after full initialisation
                loading_animation.complete();

                // remove animation hiding class from the dropdown controls
                $('#csat-report-controls').removeClass('hidden-while-loading');

                // generate initial table after loading the page
                updateReportDatatable();
            }
        };
    }
);
